import type { FilesComponentSchema } from '@iconik-io/iconik-api/src/services/files';

type ComponentsPromise = Promise<FilesComponentSchema[] | undefined>;

/**
 * The media info read from picked files, by file ref id. It is attached to the
 * format once the upload creates it, and a promise cannot live in the state.
 */
const componentsPromises = new Map<string, ComponentsPromise>();

export const setFileComponents = (
  fileRefId: string,
  promise: ComponentsPromise,
): void => {
  componentsPromises.set(fileRefId, promise);
};

export const getFileComponents = (
  fileRefId: string,
): ComponentsPromise | undefined => componentsPromises.get(fileRefId);

export const deleteFileComponents = (fileRefId: string): void => {
  componentsPromises.delete(fileRefId);
};
